module.exports = __webpack_public_path__ + "guanao-pc/static/media/position.e5d4e86e.jpg";